import { ActionIcon, Button, Group, Stack, Text, Tooltip } from '@mantine/core'
import { IconPencil, IconPlus } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'

type MqttBrokerInfoProps = {
  prefix?: string
  brokerUrl?: string
  port?: number
  onEdit: () => void
  onAdd: () => void
}

export const MqttBrokerInfo = ({
  prefix,
  brokerUrl,
  port,
  onEdit,
  onAdd
}: MqttBrokerInfoProps) => {
  const hasBrokerInfo = Boolean(brokerUrl)

  return (
    <Stack gap={4} align="start">
      <Text size="sm" fw={600}>
        <FormattedMessage id="integrations.mqtt.broker" />
      </Text>

      {hasBrokerInfo && (
        <Group wrap="nowrap" gap="xs" align="start">
          <Text size="sm" fw={500}>
            {`${prefix ?? ''}${brokerUrl}:${port}`}
          </Text>

          <Tooltip
            label={<FormattedMessage id="integrations.mqtt.broker.edit" />}
          >
            <ActionIcon variant="subtle" size="xs" radius="xl" onClick={onEdit}>
              <IconPencil style={{ width: '80%', height: '80%' }} />
            </ActionIcon>
          </Tooltip>
        </Group>
      )}

      {!hasBrokerInfo && (
        <Button
          size="compact-xs"
          leftSection={<IconPlus size={14} />}
          onClick={onAdd}
        >
          <FormattedMessage id="integrations.mqtt.broker.add" />
        </Button>
      )}
    </Stack>
  )
}
